import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";

import qoute1 from "./1.png";
import qoute12x from "./1@2x.png";
import qoute2 from "./2.png";
import qoute22x from "./2@2x.png";
import qoute3 from "./3.png";
import qoute32x from "./3@2x.png";
import { mobile } from "../../../../../../theme";

const QuoteStyled = styled("div")({
  display: "flex",
});
const QuoteImg = styled("img")({
  display: "block",
  [mobile]: {
    width: 65,
  },
});
const QuotePicture = styled("div")({
  marginRight: 30,
});

const QuoteContent = styled("div")(
  css({
    fontSize: [1, 3],
  })
);

export const quoteImages = [null, qoute1, qoute2, qoute3];
export const quoteImagesSrcSet = [
  null,
  [qoute1, `${qoute12x} 2x`],
  [qoute2, `${qoute22x} 2x`],
  [qoute3, `${qoute32x} 2x`],
];
const labels = [null, "Зумер", "Бумер", "Бумер"];

export const Quotes = styled("div")(
  css({
    [QuoteStyled]: {
      ":not(:first-child)": {
        marginTop: [50, 90],
      },
    },
  })
);

export const Quote = ({ type, children }) => (
  <QuoteStyled>
    <QuotePicture>
      <QuoteImg
        src={quoteImages[type]}
        srcSet={quoteImagesSrcSet[type].join(", ")}
      />
    </QuotePicture>
    <QuoteContent>
      <strong>{labels[type]}: </strong>
      {children}
    </QuoteContent>
  </QuoteStyled>
);
